import { Input as BaseInput } from 'antd';
import styled, { css } from 'styled-components';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import BaseMenu from '@deprecated-ui/watchlist/Menu';
import BaseModal from '@deprecated-ui/watchlist/Modal';
import Button from '@deprecated-ui/watchlist/Button';
import color from '@deprecated-ui/_style/color';

// dropdown menu
export const ButtonContainer = styled(Flex)`
  width: 100%;
  padding: 8px 0 0 0;

  button:first-child {
    margin-right: 8px;
  }

  ${
    // @ts-expect-error
    ({ block }) =>
      block &&
      css`
        border-top: solid 1px ${color.gainsboro};
        padding-top: 0px;

        button:first-child {
          margin-right: 0px;
        }
        button {
          margin: 0px;
          border: none;
          /* border-top: 1px solid ${color.gainsboro}; */
        }
      `
  }
`;

export const MenuHeader = styled(Text).attrs({
  size: '12px',
  p: '5px 8px',
  height: '20px',
  color: color.midgray,
})`
  background: ${color.light};
  border: 1px solid rgb(218, 218, 218);
  border-bottom: none;
  border-radius: 3px 3px 0 0;
`;

export const Menu = styled(BaseMenu)`
  padding: 0px;
  box-shadow: none;
  border-left: 1px solid rgb(218, 218, 218) !important;
  border-right: 1px solid rgb(218, 218, 218) !important;
  border-top: none;
  border-bottom: none;
  padding-left: 4px !important;
  max-height: 320px;
  overflow-y: scroll;

  li {
    font-size: 14px;
    margin-bottom: 4px !important;
    display: flex;
    align-items: center;
    border-radius: 3px;

    & > span {
      width: 100%;
    }
  }

  li.ant-menu-item.ant-menu-item-only-child {
    height: 28px;
    line-height: 22px;
    color: ${color.highempahis};
  }

  li.ant-menu-item-selected {
    background: ${color.whisper} !important;
  }

  li:hover,
  li.active {
    background: ${color.whisper} !important;
    color: ${color.primary};
    cursor: pointer;
    border-radius: 3px;
  }
`;

export const Modal = styled(BaseModal)`
  .ant-modal-content {
    border-radius: 3px;
  }

  .ant-modal-title {
    font-family: var(--bold-font);
    font-size: 18px;
    text-align: center;
  }
`;

export const Input = styled(BaseInput)`
  .ant-input-suffix {
    color: ${color.lowgray};
  }
`;

export const ButtonCancel = styled(Button).attrs(
  // @ts-expect-error
  { type: 'borderless' },
)`
  height: auto;
  padding: 10px 24px;
  text-align: center;

  ${({ block }) =>
    !block &&
    css`
      color: ${color.primary};
      text-transform: uppercase;
    `}
`;

export const ButtonConfirm = styled(Button).attrs({ type: 'primary' })`
  border-radius: ${({ block }) => (block ? '0px' : '3px')};
  border: none;
  height: auto;
  padding: 10px 24px;

  &:hover,
  &:active,
  &:focus {
    border: none;
  }

  ${({ block }) =>
    !block &&
    css`
      text-transform: uppercase;
    `}
`;
